/* Marguet — cartes produit v2 (29/10/2026)
   - 16 pastilles (une par couleur) ; les photos de toutes les variantes (couleur|métal) sont dans
     <script type="application/json" class="ss-card-map"> de chaque carte : { "brown|gold": ["url", variantId], ... }
   - clic pastille  -> photo de cette couleur dans le métal courant
   - clic logo M    -> même couleur, autre métal
   - les liens de la carte (photo + titre) pointent vers la variante affichée (?variant=ID)
*/
(function () {
  if (window.__marguetCardsV2) return;
  window.__marguetCardsV2 = true;

  function mapOf(card) {
    if (card.__ssMap) return card.__ssMap;
    var node = card.querySelector('script.ss-card-map');
    try { card.__ssMap = node ? JSON.parse(node.textContent) : {}; } catch (e) { card.__ssMap = {}; }
    return card.__ssMap;
  }

  function currentMetal(card) {
    if (card.dataset.ssMetal) return card.dataset.ssMetal;
    var checked = card.querySelector('input[name^="metalware-"]:checked');
    return checked ? checked.value : '';
  }

  function currentColor(card) {
    if (card.dataset.ssColor) return card.dataset.ssColor;
    var active = card.querySelector('.ss-card-color.is-active') || card.querySelector('.ss-card-color');
    return active ? active.dataset.color : '';
  }

  function apply(card, color, metal) {
    var entry = mapOf(card)[color + '|' + metal];
    if (!entry) return;
    var img = card.querySelector('.product-card__media .product-card__image--primary');
    if (img && entry[0]) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = entry[0];
    }
    card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') === -1) return;
      a.setAttribute('href', href.split('?')[0] + '?variant=' + entry[1]);
    });
    card.dataset.ssColor = color;
    card.dataset.ssMetal = metal;
  }

  // Clic sur une pastille couleur
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.ss-card-color');
    if (!btn) return;
    var card = btn.closest('.product-card');
    if (!card) return;
    card.querySelectorAll('.ss-card-color.is-active').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    apply(card, btn.dataset.color, currentMetal(card));
  });

  // Flèches desktop : faire glisser la rangée
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.ss-card-arrow');
    if (!arrow) return;
    var row = arrow.parentNode.querySelector('.ss-card-colors');
    if (!row) return;
    var dir = arrow.classList.contains('ss-card-arrow--prev') ? -1 : 1;
    row.scrollBy({ left: dir * Math.max(120, row.clientWidth * 0.8), behavior: 'smooth' });
  });

  // Début / fin de rangée : masque la flèche gauche au début et la flèche droite à la fin
  function markEdges(wrap) {
    var row = wrap.querySelector('.ss-card-colors');
    if (!row) return;
    wrap.classList.toggle('at-start', row.scrollLeft <= 1);
    wrap.classList.toggle('at-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 1);
  }

  // Marque les rangées qui débordent (les flèches ne s'affichent que dans ce cas)
  function markOverflow() {
    document.querySelectorAll('.ss-card-colors-wrap').forEach(function (wrap) {
      var row = wrap.querySelector('.ss-card-colors');
      if (!row) return;
      wrap.classList.toggle('has-overflow', row.scrollWidth > row.clientWidth + 2);
      markEdges(wrap);
      if (!row.__ssEdges) {
        row.__ssEdges = true;
        row.addEventListener('scroll', function () { markEdges(wrap); }, { passive: true });
      }
    });
  }
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(markOverflow, 150); });
  document.addEventListener('DOMContentLoaded', markOverflow);
  document.addEventListener('shopify:section:load', markOverflow);
  // Pagination / filtres Prestige : la grille est remplacée après coup (le signal facet:update part avant
  // l'arrivée des nouvelles cartes) → on surveille l'arrivée de nouvelles cartes dans la page
  var moTimer;
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches('product-card, .ss-card-colors-wrap') || node.querySelector('.ss-card-colors-wrap'))) {
          clearTimeout(moTimer);
          moTimer = setTimeout(markOverflow, 100);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') markOverflow();

  // Changement de métal (logos M)
  document.addEventListener('change', function (event) {
    var radio = event.target.closest('input[name^="metalware-"]');
    if (!radio) return;
    var card = radio.closest('.product-card');
    if (!card) return;
    var color = currentColor(card);
    if (color) apply(card, color, radio.value);
  });
})();